<div>
  <mat-toolbar>Warning</mat-toolbar>

  <mat-dialog-content class="text-center">
    <p>
      Another user is currently editing this order: <b>{{ data.lockedByUser }}</b
      >. Please return later, contact the administrator or go back to orders.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      mat-flat-button
      color="primary mb-4"
      type="button"
      class="confirm-button"
      (click)="onConfirm()"
    >
      GO BACK TO ORDERS LIST
    </button>
  </mat-dialog-actions>
</div>
